import React from 'react';

import { Icon } from '../../icon/icon';

type Props = {
  className?: string;
};

const DropIcon = (props: Props) => {
  return (
    <Icon
      className={props.className}
      fixedWidth={true}
      icon={['fad', 'arrow-down-to-dotted-line']}
    />
  );
};

export { DropIcon };
